<div *ngIf="transportForm.controls.isControlledTemperature.value || transportForm.controls.isHazardousMaterial.value" class="my-2 mx-4">
  <section id="adr" *ngIf="transportForm.controls.isHazardousMaterial.value">
    <div class="alert alert-info">
      <div class="row align-items-center">
        <div class="col-auto">
          <i class="baryicon-adr icon"></i>
        </div>
        <div class="col" jhiTranslate="estimation-transport-extra-condition.adr.info"></div>
      </div>
    </div>

    <jhi-bary-title
      [title]="'estimation-transport-extra-condition.adr.title' | translate"
      [tooltip]="'estimation-transport-extra-condition.adr.tooltip' | translate"
      [titleClass]="'bold text-dark mb-0'"
    ></jhi-bary-title>

    <div class="col-12" *ngFor="let transportExtraConditionForm of transportForm.controls.transportExtraConditions; index as index">
      <div class="row adr-line py-2 align-items-center">
        <div class="w-20">
          <span>{{ index + 1 }}</span>
        </div>
        <div class="col">
          <div class="row text-left align-items-center" *ngIf="transportExtraConditionForm.controls.adrIsLimitedQuantity.value === true">
            <div class="col-4 col-md-2 adr-table">
              <img class="adr-image img-fluid" src="/content/images/limited_quantity.png" alt="limited_quantity" />
              <img class="img-fluid" alt="dangerous" src="/content/images/dangerous-for-env.png" *ngIf="transportExtraConditionForm.controls.adrIsDangerousForEnvironment.value" />
            </div>
            <div class="col">
              {{ 'Quantité limitée' }}
            </div>
            <div class="col-2 text-right">
              {{ transportExtraConditionForm.controls.adrNetWeight.value + ' Kg ou L' }}
            </div>
          </div>
          <div class="row text-left align-items-center" *ngIf="!transportExtraConditionForm.controls.adrIsLimitedQuantity.value">
            <div class="col-4 col-md-2 adr-table">
              <img class="adr-image img-fluid" src="/content/images/logo-adr.png" alt="adr" />
              <img class="img-fluid" alt="dangerous" src="/content/images/dangerous-for-env.png" *ngIf="transportExtraConditionForm.controls.adrIsDangerousForEnvironment.value" />
            </div>
            <div class="col">
              {{ getAdrLine(transportExtraConditionForm) }}
            </div>
            <div class="col-2 text-right">
              {{ transportExtraConditionForm.controls.adrNetWeight.value + ' Kg ou L' }}
            </div>
          </div>
        </div>
        <div>
          <a class="pr-1" (click)="editADR(transportExtraConditionForm)">
            <jhi-bary-icon icon="pen" [faDirective]="FAS"></jhi-bary-icon>
          </a>
          <a (click)="removeExtraCondition(index)">
            <jhi-bary-icon icon="trash-alt" [faDirective]="FAS"></jhi-bary-icon>
          </a>
        </div>
      </div>
    </div>
    <div class="text-center pt-3">
      <jhi-bary-button [label]="'Ajouter une matière dangereuse'" (clickEvent)="addNewADR()"></jhi-bary-button>
    </div>
  </section>

  <section id="controlled-temperature" *ngIf="transportForm.controls.isControlledTemperature.value">
    <div class="alert alert-info">
      <div class="row align-items-center">
        <div class="col-auto">
          <i class="baryicon-frozen fa-3x icon"></i>
        </div>
        <div class="col" jhiTranslate="estimation-transport-extra-condition.controlledTemperature.info"></div>
      </div>
    </div>

    <jhi-bary-title
      [title]="'estimation-transport-extra-condition.controlledTemperature.title' | translate"
      [tooltip]="'estimation-transport-extra-condition.controlledTemperature.tooltip' | translate"
      [titleClass]="'bold text-dark mb-0'"
    ></jhi-bary-title>

    <div class="w-100">
      <div class="align-items-center">
        <div class="">
          <jhi-bary-options-selector
            widthCell="w-bary-xl"
            heightCell="h-bary-lg"
            [options]="controlledTemperatureOptions"
            [control]="controlledTemperatureTypeControl"
          ></jhi-bary-options-selector>
        </div>
        <div class="w-100">
          <jhi-bary-input-number
            [label]="'estimation-transport-extra-condition.controlledTemperature.temperature' | translate"
            [control]="transportForm.controls.transportExtraConditions[0].controls.controlledTemperature"
            [min]="-30"
            [max]="20"
          ></jhi-bary-input-number>
        </div>
      </div>
    </div>
  </section>
</div>
